import React from 'react'
import MobileR18Alert from './MobileR18Alert'
import DesktopR18Alert from './DesktopR18Alert'

const Index = () => {
  return (
    <>
      <MobileR18Alert />
      <DesktopR18Alert />
    </>
  )
}

export default Index
